import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Dropdown } from "react-bootstrap";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { jwtDecode } from "jwt-decode";

import { getProfileData } from '../../../Redux/action/MasterAction';
import { getTutorSmallNotificationListData } from '../../../Redux/action/TutorAction';
import axios from 'axios';

const host = process.env.REACT_APP_API_SERVER
const TutorHeader = () => {
    const authToken = localStorage.getItem('tutor-token');
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(prev => !prev);
    };
    useEffect(() => {
        if (authToken) {
            const decoded = jwtDecode(authToken);

            if (!decoded?.user?.id) {
                localStorage.removeItem("tutor-token");
                navigate('/login', { state: { user: 'tutor' } })
            }
            else {
                localStorage.removeItem("student-token");
            }
        }
        else {

            navigate('/login', { state: { user: 'tutor' } })
        }

    }, [authToken, navigate])


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getProfileData(authToken))
        dispatch(getTutorSmallNotificationListData(authToken))
    }, []);

    const {
        loadingProfileDataListApi,
        ProfileDataListApiData,
        ProfileDataListApiError,

    } = useSelector(state => state?.MasterReducer);

    const {

        loadingTutorSmallNotificationListApi,
        TutorSmallNotificationListApiData,
        TutorSmallNotificationListApiError

    } = useSelector(state => state?.TutorReducer);


    const markNotificationsAsRead = async (notificationId) => {
        try {
            const config = {
                headers: {
                    "x-auth-token": localStorage.getItem('tutor-token'), // Custom header with the token
                }
            }

            const response = await axios.post(`${host}/api/web/notification-read`, {
                notificationId,
            }, config);
            dispatch(getTutorSmallNotificationListData());
            navigate('/tutor/notification')

        } catch (error) {
            console.error('Error marking notifications as read:', error);
        }
    };

    const handleViewAllClick = () => {
        const allNotificationIds = TutorSmallNotificationListApiData.map((data) => data.id);
        markNotificationsAsRead(allNotificationIds);
    };

    const handleNotificationClick = (notificationId) => {
        markNotificationsAsRead([notificationId]);
    };

    if (ProfileDataListApiError) {
        console.log('err', ProfileDataListApiError)

        if (ProfileDataListApiError == "Your account has been logged in from another device. Please sign in again.") {
            localStorage.removeItem("tutor-token");
            navigate('/login', { state: { user: 'tutor' } });
        }
    }

    return (
        <div className="header-top-sec  bg-light">
            <header>
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid px-5">
                        <div className="row header-row">
                            <div className="col-lg-2 col-md-3 col-sm-2 weblogo">
                                <Link className="navbar-brand" href="#">
                                    <img src="/website/assets/img/logo.png" className="img-fluid" />
                                </Link>
                            </div>
                            <div className="col-lg-7 col-md-5 col-sm-6 header-text">
                                <h4 className="mb-0 fw-lighter">Hello, {ProfileDataListApiData?.data?.name}</h4>
                                <p className="mb-0">
                                    Start helping students in exploring their true interest!
                                </p>
                            </div>
                            <div className="col-lg-3 col-md-3  col-sm-3 notification-profile-sec">
                                <ul className="navbar-nav mb-2 mb-lg-0">
                                    <li className="nav-item dropdown">

                                        <Dropdown>
                                            <Dropdown.Toggle variant="link" drop="start">
                                                <i className="fa-solid fa-bell" />
                                                <span className="badge badge-warning navbar-badge text-danger">
                                                    {TutorSmallNotificationListApiData?.length ? TutorSmallNotificationListApiData?.length : '0'}
                                                </span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'scroll' }}>
                                                {TutorSmallNotificationListApiData?.length > 0 ? (
                                                    <>
                                                        {TutorSmallNotificationListApiData.map((data, index) => (
                                                            <Dropdown.Item
                                                                key={index}

                                                                onClick={() => handleNotificationClick(data.id)} // Call API for individual notification
                                                            >
                                                                <i className="fas fa-envelope mr-2"></i> {data?.message}
                                                            </Dropdown.Item>
                                                        ))}
                                                        {TutorSmallNotificationListApiData.length > 2 && (
                                                            <Dropdown.Item

                                                                className="text-center fw-bold border-1 border-top"
                                                                onClick={handleViewAllClick} // Call API for all notifications
                                                            >
                                                                View All Notifications
                                                            </Dropdown.Item>
                                                        )}
                                                    </>
                                                ) : (
                                                    <Dropdown.Item disabled>No notifications available</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <Dropdown>
                                            <Dropdown.Toggle variant="link">
                                                <img
                                                    src={`${host}${ProfileDataListApiData?.data?.profile_img}`}
                                                    className="rounded-circle"

                                                    alt="User Avatar"
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as={Link} to="/tutor/profile-settings">
                                                    Profile
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Link} data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal">
                                                    Logout
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-0 col-md-1 col-sm-1 d-flex align-items-center justify-content-center asidebar">
                                <button id="sidebarToggle" className="navbar-toggler" type="button" onClick={toggleSidebar}>
                                    <span className="navbar-toggler-icon" />
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

            {isSidebarOpen && (
                <div className="responsive-sidebar navbar-light">
                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                        <h5 className="mb-0">Menu</h5>
                        <button className="btn btn-link text-dark fs-4" onClick={toggleSidebar}>
                            <i className="fa fa-times" />
                        </button>
                    </div>
                    <ul className="nav flex-column p-3 navbar-nav">
                        <li className="nav-item">
                            <Link
                                className={`${(pathname == '/tutor/dashboard') ? 'active nav-link' : 'nav-link'}`}
                                aria-current="page"
                                to="/tutor/dashboard"
                            >
                                <i className="fa-solid fa-house-chimney" />
                                &nbsp;Dashboard
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${(pathname == '/tutor/my-students' || pathname == '/tutor/my-students-group') ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-students">
                                <i className="fas fa-graduation-cap" />
                                &nbsp;My Students
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/study-material' ? 'active nav-link' : 'nav-link'}`} to="/tutor/study-material">
                                <i className="fas fa-book-reader" />
                                &nbsp;Study Materials
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${(pathname == '/tutor/my-courses' || pathname == '/tutor/add-new-group-course' || pathname == '/tutor/group-course-list' || pathname == '/tutor/booked-schedule') ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-courses">
                                <i className="fas fa-calendar-alt" />
                                &nbsp;My Courses
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/my-earnings' ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-earnings">
                                <i className="fas fa-hand-holding-usd" />
                                &nbsp;My Earnings
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/browse-students' ? 'active nav-link' : 'nav-link'}`} to="/tutor/browse-students">
                                <i className="fas fa-chalkboard-teacher" />
                                &nbsp;Browse Students
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${(pathname == '/tutor/my-assessments-main' || pathname == '/tutor/add-objective-assessment' || pathname == '/tutor/add-subjective-assessment' || pathname == '/tutor/completed-assessment' || pathname == '/tutor/view-assessment-course') ? 'active nav-link' : 'nav-link'}`} to="/tutor/my-assessments-main">

                                <i className="fas fa-laptop-code" />
                                &nbsp;My Assessments
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/bookings' ? 'active nav-link' : 'nav-link'}`} to="/tutor/bookings">
                                <i className="fa fa-clock-o" />
                                &nbsp;Booking
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${(pathname == '/tutor/message' || pathname == '/tutor/chat') ? 'active nav-link' : 'nav-link'}`} to="/tutor/message">
                                <i className="fa-solid fa-comments" />
                                &nbsp;Message
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/student-queries' ? 'active nav-link' : 'nav-link'}`} to="/tutor/student-queries">
                                <i className="fa-solid fa-clipboard-question" />
                                &nbsp;Student Queries
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/contact-us' ? 'active nav-link' : 'nav-link'}`} to="/tutor/contact-us">
                                <i className="fa-solid fa-users" />
                                &nbsp;Contact us
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${pathname == '/tutor/reviews' ? 'active nav-link' : 'nav-link'}`} to="/tutor/reviews">
                                <i className="fa-solid fa-star" />
                                &nbsp;Reviews
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`${(pathname == '/tutor/profile-settings' || pathname == '/tutor/profile-settings-personal-info' || pathname == '/tutor/profile-settings-bank-details' || pathname == '/tutor/profile-settings-updated-tutoring-price' || pathname == '/tutor/profile-settings-tutor-teaching-list' || pathname == '/tutor/profile-settings-cip') ? 'active nav-link' : 'nav-link'}`} to="/tutor/profile-settings">
                                <i className="fa fa-user-circle-o" />
                                &nbsp;Profile
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className="nav-link btn text-start"

                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                            >
                                <i className="fa-solid fa-right-from-bracket" />
                                &nbsp;Logout
                            </Link>
                        </li>
                    </ul>
                </div>
            )}
        </div>

    )
}

export default TutorHeader